import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/webflow.css';
import '../css/normalize.css';
import '../css/manmade-cycle-main.webflow.css';
import '../css/PriceSection.css';
import image1 from '../images/Group-1000002493.svg';
const PriceSection = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('yearly');
  const [s_plan, s_setPlan] = useState([]);
  const [s_feature, s_setFeature] = useState([]);

  useEffect(() => {
    // Fetch the data from the PHP API
    const fetchData = async () => {
      try {
        const response = await fetch('https://app.furloop.io/api/reseller/subscription_plan.php');
        const result = await response.json();

        if (result.status === 'success') {

          s_setPlan(result.s_plan_data);
          s_setFeature(result.s_features_data);

        } else {
          console.error('Error:', result.message);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchData();
  }, []);



  // Function to get features for specific Monthly subscription plans
  const getFilteredMonthlyPlans = (plans = [], features = []) => {

    const filteredPlans = plans.filter(plan =>
      (plan.s_name === "Basic" && plan.s_type === "monthly") ||
      (plan.s_name === "Plus" && plan.s_type === "monthly") ||
      (plan.s_name === "Enterprise" && plan.s_type === "monthly")
    );

    return filteredPlans.map(plan => {
      const planFeatures = features.filter(feature => feature.plan_id === plan.id);
      return {
        ...plan,
        features: planFeatures
      };
    });
  };

  const getMonthlyPlans = getFilteredMonthlyPlans(s_plan, s_feature);

// Function to get features for specific Yearly subscription plans
const getFilteredYearlyPlans = (plans = [], features = []) => {

  const filteredPlans = plans.filter(plan =>
    (plan.s_name === "Basic" && plan.s_type === "yearly") ||
    (plan.s_name === "Plus" && plan.s_type === "yearly") ||
    (plan.s_name === "Enterprise" && plan.s_type === "yearly")
  );

  return filteredPlans.map(plan => {
    const planFeatures = features.filter(feature => feature.plan_id === plan.id);
    return {
      ...plan,
      features: planFeatures
    };
  });
};

const getYearlyPlans = getFilteredYearlyPlans(s_plan, s_feature);



 //Conditions for Monthly Plan
  const basicMonthlyPlan = getMonthlyPlans?.filter(
    plan => plan.s_name === 'Basic' && plan.s_type === 'monthly'
  ) || [];

  const plusMonthlyPlan = getMonthlyPlans?.filter(
    plan => plan.s_name === 'Plus' && plan.s_type === 'monthly'
  ) || [];

  const enterpriseMonthlyPlan = getMonthlyPlans?.filter(
    plan => plan.s_name === 'Enterprise' && plan.s_type === 'monthly'
  ) || [];


  //Condition for Yearly Plan
  const basicYearlyPlan = getYearlyPlans?.filter(
    plan => plan.s_name === 'Basic' && plan.s_type === 'yearly'
  ) || [];

  const plusYearlyPlan = getYearlyPlans?.filter(
    plan => plan.s_name === 'Plus' && plan.s_type === 'yearly'
  ) || [];

  const enterpriseYearlyPlan = getYearlyPlans?.filter(
    plan => plan.s_name === 'Enterprise' && plan.s_type === 'yearly'
  ) || [];

  const handleTabClick = (e, tab) => {
    e.preventDefault();
    setActiveTab(tab);
  };

  const handleGetStarted = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = '/sign-up-today';
  };

  return (
    <>
      <div className="content">
        <div className="container">
          <div className="content-wrap-2">
            <div className="content-heading div-block">
              <h1 className="heading-pricing">Pick the plan that suits you best</h1>
            </div>
            <div className="content-text">
              <h5 className="">* All plans include 14-Day free trial <br /></h5>
            </div>
            <div className="tabs">
              <div className="tabs-menu-2" id="pricing">
                <button type="button" className={`tab-link-monthly ${activeTab === 'monthly' ? 'w--current' : ''}`}
                  onClick={(e) => handleTabClick(e, 'monthly')}>
                  Pay Monthly
                </button>
                <button type="button" className={`tab-link-yearly ${activeTab === 'yearly' ? 'w--current' : ''}`}
                  onClick={(e) => handleTabClick(e, 'yearly')}>
                  Pay Yearly
                </button>
              </div>
              <div className="tabs-content-2">
                <div className={`monthly ${activeTab === 'monthly' ? 'w--tab-active' : ''}`} style={{display: activeTab === 'monthly' ? 'block' : 'none'}}>
                  <div className="content-cards">
                    {/* Card 1 */}
                    <div className="card">
                      <div className="card-wrap">
                        <div className="card-top">
                          <div className="card-heading">
                            <h2 className="mb-20">{basicMonthlyPlan[0]?.s_name}</h2>
                            <p className="paragraph-6">{basicMonthlyPlan[0]?.s_description}</p>
                          </div>

                        </div>
                        <div className="card-bot">
                          {
                            basicMonthlyPlan[0]?.features?.map((featureM) => (
                              <div className="check" key={featureM.id}>
                                  <img loading="lazy" src={image1} alt="" />
                                   <p><span className="purple-holder">{featureM.feature_text}</span></p>
                               </div>
                            ))
                          }

                        </div>

                      </div>
                      <div className="mb-4">
                      <div className="card-price d-flex justify-content-center">
                            <p className="price-color"><span className="p-22">${basicMonthlyPlan[0]?.price}</span>/mo</p>
                          </div>
                        <button type="button" onClick={handleGetStarted} className="button-2 big" style={{display: 'flex', justifyContent: 'center', border: 'none', cursor: 'pointer', width: '100%'}}>
                          Get Started
                        </button>
                        </div>
                    </div>

                    {/* Card 2 */}
                    <div className="card mid">
                      <div className="card-wrap mid">
                        <div className="card-top">
                          <div className="card-heading">
                            <h1 className=" heading-2 d-flex align-items-center justify-content-between">
                              <span className="gradeint-header-pricing-medium">{plusMonthlyPlan[0]?.s_name}</span>
                              <span className="badge-1">Popular</span>
                            <br /></h1>
                            <p className="paragraph-7">{plusMonthlyPlan[0]?.s_description}</p>
                          </div>

                        </div>
                        <div className="card-bot">
                        {
                            plusMonthlyPlan[0]?.features?.map((featureM) => (
                              <div className="check" key={featureM.id}>
                                  <img loading="lazy" src={image1} alt="" />
                                   <p><span className="purple-holder">{featureM.feature_text}</span></p>
                               </div>
                            ))
                          }

                        </div>
                      </div>
                      <div className="mb-4">
                      <div className="card-price d-flex justify-content-center">
                            <p className="price-color"><span className="p-22">${plusMonthlyPlan[0]?.price}</span>/mo</p>
                          </div>
                        <button type="button" onClick={handleGetStarted} className="button-2 big" style={{display: 'flex', justifyContent: 'center', border: 'none', cursor: 'pointer', width: '100%'}}>
                          Get Started
                        </button>
                        </div>
                    </div>

                    {/* Card 3 */}
                    <div className="card">
                      <div className="card-wrap">
                        <div className="card-top">
                          <div className="card-heading">
                            <h2 className="mb-20">{enterpriseMonthlyPlan[0]?.s_name}</h2>
                            <p className="paragraph-8">{enterpriseMonthlyPlan[0]?.s_description}</p>
                          </div>

                        </div>
                        <div className="card-bot">
                        {
                            enterpriseMonthlyPlan[0]?.features?.map((featureM) => (
                              <div className="check" key={featureM.id}>
                                  <img loading="lazy" src={image1} alt="" />
                                   <p><span className="purple-holder">{featureM.feature_text}</span></p>
                               </div>
                            ))
                          }

                        </div>
                      </div>
                      <div className="mb-4">
                      <div className="card-price d-flex justify-content-center">
                            <p className="price-color"><span className="p-22">${enterpriseMonthlyPlan[0]?.price}</span> one-time</p>
                          </div>
                        <button type="button" onClick={handleGetStarted} className="button-2 big" style={{display: 'flex', justifyContent: 'center', border: 'none', cursor: 'pointer', width: '100%'}}>
                          Get Started
                        </button>
                        </div>
                    </div>
                  </div>
                </div>

                {/* Tab 2 */}
                <div className={`yearly ${activeTab === 'yearly' ? 'w--tab-active' : ''}`} style={{display: activeTab === 'yearly' ? 'block' : 'none'}}>
                  <div className="content-cards">
                    {/* Card 1 */}
                    <div className="card">
                      <div className="card-wrap">
                        <div className="card-top">
                          <div className="card-heading">
                            <h2 className="mb-20">{basicYearlyPlan[0]?.s_name}</h2>
                            <p className="paragraph-10">{basicYearlyPlan[0]?.s_description}</p>
                          </div>

                        </div>
                        <div className="card-bot">
                        {
                            basicYearlyPlan[0]?.features?.map((feature) => (
                              <div className="check" key={feature.id}>
                                  <img loading="lazy" src={image1} alt="" />
                                   <p><span className="purple-holder">{feature.feature_text}</span></p>
                               </div>
                            ))
                          }

                        </div>


                      </div>
                        <div className="card-price ">
                            <p className="price-color d-flex justify-content-center align-items-center">
                              <span className="strike">${basicMonthlyPlan[0]?.price}/mo</span>
                              <sup>$</sup><span className="p-22">{basicYearlyPlan[0]?.price}</span>/mo</p>
                            <p className="p-12">billed annually at $300</p>
                          </div>
                      <div className="mb-4">
                        <button type="button" onClick={handleGetStarted} className="button-2 big" style={{display: 'flex', justifyContent: 'center', border: 'none', cursor: 'pointer', width: '100%'}}>
                          Get Started
                        </button></div>
                    </div>

                    {/* Card 2 */}
                    <div className="card mid">
                      <div className="card-wrap mid">
                        <div className="card-top">
                          <div className="card-heading">
                            <h2 className="mb-20">{plusYearlyPlan[0]?.s_name}</h2>
                            <p className="paragraph-11">{plusYearlyPlan[0]?.s_description}</p>
                          </div>

                        </div>
                        <div className="card-bot">
                        {
                            plusYearlyPlan[0]?.features?.map((feature) => (
                              <div className="check" key={feature.id}>
                                  <img loading="lazy" src={image1} alt="" />
                                   <p><span className="purple-holder">{feature.feature_text}</span></p>
                               </div>
                            ))
                          }


                        </div>


                      </div>
                      <div className="mb-4">


                          <div className="card-price ">
                            <p className="price-color d-flex justify-content-center align-items-center">
                            <span className="strike">${plusMonthlyPlan[0]?.price}/mo</span> <sup>$</sup>
                              <span className="p-22">{plusYearlyPlan[0]?.price}</span>/mo</p>
                            <p className="p-12">billed annually at $624</p>
                          </div>


                        <button type="button" onClick={handleGetStarted} className="button-2 big" style={{display: 'flex', justifyContent: 'center', border: 'none', cursor: 'pointer', width: '100%'}}>
                          Get Started
                        </button></div>
                    </div>

                    {/* Card 3 */}
                    <div className="card">
                      <div className="card-wrap">
                        <div className="card-top">
                          <div className="card-heading">
                            <h2 className="mb-20">{enterpriseYearlyPlan[0]?.s_name}</h2>
                            <p className="paragraph-12">{enterpriseYearlyPlan[0]?.s_description}</p>
                          </div>

                        </div>
                        <div className="card-bot">
                        {
                            enterpriseYearlyPlan[0]?.features?.map((feature) => (
                              <div className="check" key={feature.id}>
                                  <img loading="lazy" src={image1} alt="" />
                                   <p><span className="purple-holder">{feature.feature_text}</span></p>
                               </div>
                            ))
                          }

                        </div>


                      </div>
                      <div className="mb-4">
                      <div className="card-price d-flex justify-content-center">
                            <p className="price-color"><span className="p-22">${enterpriseYearlyPlan[0]?.price}</span> one-time</p>
                          </div>
                        <button type="button" onClick={handleGetStarted} className="button-2 big" style={{display: 'flex', justifyContent: 'center', border: 'none', cursor: 'pointer', width: '100%'}}>
                          Get Started
                        </button>
                        </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default PriceSection;
